import React from 'react'
import { Box, CircularProgress } from '@mui/material/';

const Loader = () => (
  <Box sx={{ display: 'flex' }}>
      <CircularProgress />
  </Box>
)

export default Loader
